import React, { useRef, useEffect } from 'react';

import PropTypes from 'prop-types';

import axios from 'axios';

export default function VideoMessage({ message }) {
  const ref = useRef(null);

  const checkEmbeddedVideo = (videoPlaceholder) => {
    const { path } = videoPlaceholder.dataset;

    axios
      .get(path)
      .then((result) => {
        const videoStr = result.data.data.embedded_video;

        if (videoStr.includes('video-placeholder')) {
          setTimeout(() => {
            checkEmbeddedVideo(videoPlaceholder);
          }, 20000); // call again after 20 seconds
        } else {
          const div = document.createElement('div');
          div.innerHTML = videoStr.trim();
          const video = div.firstChild;

          videoPlaceholder.replaceWith(video);
        }
      });
  };

  useEffect(() => {
    if (ref.current) {
      const videoPlaceholder = ref.current.querySelector('.video-placeholder');
      if (videoPlaceholder) {
        checkEmbeddedVideo(videoPlaceholder);
      }
    }
  }, [ref]);

  return (
    <div className="rce-container-mbox">
      <div className="rce-mbox rce-mbox-right rce-mbox--clear-padding">
        <div className="rce-mbox-body" ref={ref}>
          <div dangerouslySetInnerHTML={{ __html: message.video_content }} />
        </div>
      </div>
    </div>
  );
}

VideoMessage.propTypes = {
  message: PropTypes.object.isRequired,
};
